export const AJOUTE_CRENEAU = "AJOUTE_CRENEAU";
export const SUPRIMER_CRENEAU = "SUPRIMER_CRENEAU";